import React from 'react';

// Colorea el badge según el código de estado, sin hardcodear la lista de
// estados en la UI: si el backend agrega uno nuevo, cae en el caso neutro.
function claseParaEstado(estado) {
  if (!estado) return 'badge-neutral';
  const codigo = estado.codigo || '';
  if (codigo === 'entregado') return 'badge-success';
  if (codigo === 'cancelado_devuelto' || codigo === 'retenido_ecuafly' || codigo === 'entregado_ecuafly') return 'badge-error';
  if (estado.requiere_accion_cliente) return 'badge-warning';
  return 'badge-accent';
}

export default function EstadoBadge({ estado }) {
  if (!estado) return <span className="badge badge-neutral">Sin estado</span>;
  return <span className={`badge ${claseParaEstado(estado)}`}>{estado.nombre}</span>;
}
